<template>
  <div class="col border-white">
    <div class="row">
      <div class="col-1">
        <h3 class="sous-section">Rôles</h3>
      </div>
    </div>
    <div class="row"/>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-2 lbl">
          </div>
          <div class="col-2 lbl">
            <label>Groupe de sécurité source :</label>
          </div>
          <div class="col-5 lbl">
            <label>Groupe de sécurité destination :</label>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-4">
            <Dropdown v-model="groupeSource"
                      :options="groupeSourceLibelles" optionValue="cle"
                      optionLabel="nom" scrollHeight="205px" :showClear="true"/>
          </div>
          <div class="col-1">
          </div>
          <div class="col-4">
            <Dropdown v-model="groupeDestination"
                      :options="groupeDestinationLibelles" optionValue="cle"
                      optionLabel="nom" scrollHeight="205px" :showClear="true"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-2 lbl">
        <label>Groupes :</label>
      </div>
      <div class="col-9">
        <vue-list-picker title-left="Disponibles" title-right="Attribués" min-height="120px" :content-substr=100 class="left"
                         :left-items="leftRolesDisponibles" :right-items="rightRolesAttribues"/>
      </div>
    </div>
    <div class="row"/>
  </div>
  <div class="row"/>
</template>

<script>
import {mapGetters} from 'vuex';
import {VueListPicker} from 'vue-list-picker';
import axios from "axios";

export default {
  name: 'CriteresRechercheRolesGroupe',
  emits: ['fermer'],
  components: {
    VueListPicker
  },
  data() {
    return {
      groupeSource: null,
      groupeDestination: null,
      groupeSourceLibelles: [],
      groupeDestinationLibelles: [],
      listDisponibles: [],
      listAttribues: [],
      leftRolesDisponibles: [],
      rightRolesAttribues: [],
    };
  },
    computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  beforeMount() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("pilotage/rechercherGroupesSecuriteAction", null).then((res) => {
      this.groupeSourceLibelles = res.data.sort((a, b) => {
        return this.$commun.compareString(a.nom, b.nom)
      });
      this.groupeDestinationLibelles = res.data.sort((a, b) => {
        return this.$commun.compareString(a.nom, b.nom)
      });
    });
  },
  methods: {
    getGroupe() {
      return this.groupeDestination;
    },
    getRolesAttribues() {
      let rolesAttribues = [];
      for (let i = 0; i < this.rightRolesAttribues.length; i++) {
        rolesAttribues.push({
          cleGroupeSecurite: this.groupeDestination,
          cleRoleSecurite: this.rightRolesAttribues[i].key,
        })
      }
      return rolesAttribues;
    },
    getRolesSource() {
      // De Groupe Source qui n'est pas déjà dans le groupe de destination
      this.leftRolesDisponibles.splice(0);
      if (this.groupeSource) {
        this.$root.$refs.breadcrumbComp.activeBallBeat = true;
        this.$store.dispatch('pilotage/obtenirGroupeSecuriteCleRoleAction', this.groupeSource)
            .then((res) => {
              this.listDisponibles = res.data.sort((a, b) => {
                return this.$commun.compareString(a.role, b.role)
              });
              this.listDisponibles = this.listDisponibles.filter(rd => !this.rightRolesAttribues.find(ra => (ra.key === rd.cle)));
              for (let i = 0; i < this.listDisponibles.length; i++) {
                this.leftRolesDisponibles.push({
                  key: this.listDisponibles[i].cle,
                  content: this.listDisponibles[i].role,
                })
              }
              this.$root.$refs.breadcrumbComp.activeBallBeat = false;
            });
      }
    },
    getRolesDestination() {
      // De Groupe Destination
      this.rightRolesAttribues.splice(0);
      if (this.groupeDestination) {
        this.$root.$refs.breadcrumbComp.activeBallBeat = true;
        this.$store.dispatch('pilotage/obtenirGroupeSecuriteCleRoleAction', this.groupeDestination)
            .then((res) => {
              this.listAttribues = res.data.sort((a, b) => {
                return this.$commun.compareString(a.role, b.role)
              });
              for (let i = 0; i < this.listAttribues.length; i++) {
                this.rightRolesAttribues.push({
                  key: this.listAttribues[i].cle,
                  content: this.listAttribues[i].role,
                })
              }
              this.getRolesSource();
              this.$root.$refs.breadcrumbComp.activeBallBeat = false;
            });
      }
    },
  },
  watch: {
    'groupeSource': function () {
      this.getRolesSource();
    },
    'groupeDestination': function () {
      this.getRolesDestination();
    },
  }
}
</script>